import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../Context/AppContext";
import styles from "../../Pages/Cart.module.css";
const OrderSummary = () => {
  const {cartData,setCartData}=useContext(AppContext)
  const [totalCost, setTotalCost] = useState(0);
  const [tax, setTax] = useState(0);
  const [total, setTotal] = useState(0);
  const [saving,setSaving]=useState(0)
 useEffect(()=>{
  let total=0;
  let sav=0;
  console.log(cartData)
  for(let i=0; i<cartData.length; i++){
    total=total+cartData[i].salePrice
    sav=sav+200;
  }
  setSaving(sav)
  setTotalCost(Math.floor(total))
 },[])
 function checkOut(){
  alert("Order placed successfull")
  setCartData([])
  setTotalCost(0)
  setSaving(0)
 }
  console.log(cartData);
  return (
    <div className={styles.order_summary}>
      <h2>Order Summary</h2>
      <div className={styles.totalDiv}>
        <div>
          <p>Original Price</p>
          <p>${totalCost+saving}</p>
        </div>
        <div>
          <p>Savings</p>
          <p>${saving}</p>
        </div>
        <div>
          <p>Store Pickup</p>
          <p>FREE</p>
        </div>
        <div className={styles.tax}>
          <p>Estimated Sales Tax</p>
          <p>${tax}</p>
        </div>
      </div>
      <div className={styles.total}>
        <h3>Total</h3>
        <h3>${totalCost}</h3>
      </div>
      
        <button onClick={checkOut} className={styles.checkoutBtn}>Checkout</button>
      <button className={styles.paypalBtn}>
        <i>Paypal</i>
        <span>Checkout</span>
      </button>
      <p>
        <Link to="/signup">Sign in or create an account now</Link> to get My
        Best Buy™ Points
      </p>
    </div>
  );
};

export default OrderSummary;